// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"62ef141a","453":"0e3563b4"}[chunkId] + ".chunk.js";
};